import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router'
import { ValueMetricsPerYearMonth } from '@camunda-cloud/cloud-node-libs'
import { iif, Observable, of } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { OrgService } from '../services/org.service'
import { ViewVisibilitiesService } from '../services/view.visibilities.service'

@Injectable({
  providedIn: 'root',
})
export class ValueMetricsResolverService
  implements Resolve<ValueMetricsPerYearMonth[]> {
  constructor(
    private vvs: ViewVisibilitiesService,
    private orgService: OrgService,
  ) {}
  // eslint-disable-next-line class-methods-use-this
  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ValueMetricsPerYearMonth[]> {
    return this.vvs
      .get(route.paramMap.get('orgUuid'))
      .pipe(
        mergeMap((visibilities) =>
          iif(
            () =>
              visibilities.billing.valueMetrics.read.visible &&
              !visibilities.billing.subscriptionsAvailable.visible &&
              !visibilities.billing.view.enterprise.visible,
            this.orgService.getValueMetrics(route.paramMap.get('orgUuid')),
            of([]),
          ),
        ),
      )
  }
}
